export default "__VITE_ASSET__pndxwBTL__"